import { useEffect, useState } from 'react'

export function useScreenSize() {
    const [innerWith, setInnerWith] = useState(window.innerWidth)

    const asyncUpdatedWindowSize = async () => {
        const id = setTimeout(() => {
            setInnerWith(window.innerWidth)
            clearTimeout(id)
        }, 400)
    }

    useEffect(() => {
        window.addEventListener('resize', asyncUpdatedWindowSize)
        return () => {
            window.removeEventListener('resize', asyncUpdatedWindowSize, false)
        }
    }, [])

    const isDesktop = () => innerWith >= 1024

    return {
        isDesktop,
    }
}
